<script setup lang="ts">
import { AbcToggle } from "@ordbogen-npm/abc-dsk";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import TgSavedToast from "@/abc-dsk/components/SavedToast/TgSavedToast.vue";
import { MatomoHelper } from "@/helpers";
import { useSettingsStore } from "@/stores";
import { MatomoEventAction, MatomoEventCategory } from "@/types";

const { t } = useI18n();

const settingsStore = useSettingsStore();

const allowHelpTools = computed<boolean>(() => settingsStore.userPreferences.allowHelpTools);

const updatedHelpToolsToast = ref(true);

const setAllowHelpTools = async (value: boolean) => {
  updatedHelpToolsToast.value = false;
  await settingsStore.setAllowHelpTools(value);
  updatedHelpToolsToast.value = true;

  MatomoHelper.sendEvent(
    MatomoEventCategory.AbcSettings,
    MatomoEventAction.ExamSettings,
    `Toggled dictionary support tools to ${value}`
  );
};
</script>

<template>
  <div>
    <div class="settings-group">
      <h2 class="settings-group__heading settings-group__heading--big d-none d-lg-block mb-0">
        {{ t("settings.exam.title") }}
      </h2>
      <p class="settings-group__subheading mb-0">
        {{ t("settings.exam.subheading") }}
      </p>
    </div>
    <hr class="settings-group-divider d-none d-lg-block" />
    <div class="settings-group row">
      <div class="col-9 col-lg-12 settings-group__content flex-column flex-fill">
        <h3 class="settings-group__heading">{{ t("settings.exam.smartComplete.heading") }}</h3>
        <p class="settings-group__subheading my-1">
          {{ t("settings.exam.smartComplete.description") }}
        </p>
        <p class="settings-group__subheading">
          {{ t("settings.exam.smartComplete.disclaimer") }}
        </p>
      </div>
      <div
        class="col-3 col-lg-12 settings-group__content justify-content-end justify-content-lg-start"
      >
        <TgSavedToast
          v-model:show="updatedHelpToolsToast"
          :top="-16"
          :left="-24"
          absolute
          class="d-lg-none"
        />
        <AbcToggle
          :model-value="allowHelpTools"
          :aria-label="t('settings.exam.smartComplete.heading')"
          @update:model-value="setAllowHelpTools($event)"
        />
        <TgSavedToast v-model:show="updatedHelpToolsToast" class="d-none d-lg-flex ml-3" />
      </div>
      <div class="col-9 col-lg-12 settings-group__content flex-column flex-fill">
        <h3 class="settings-group__heading">{{ t("settings.exam.speechToText.heading") }}</h3>
        <p class="settings-group__subheading my-1 text-with-newline">
          {{ t("settings.exam.speechToText.description") }}
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.text-with-newline {
  white-space: pre-line;
}
</style>
